import { React, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaRegTrashAlt } from "react-icons/fa";

export default function ProductA({
  items,
  handleDeleteProduct,
  onUploadSuccess,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [deletingId, setDeletingId] = useState(null);
  const [removingId, setRemovingId] = useState(null);
  const itemsPerPage = 10;

  console.log("items A:", items);

  const handleNextPage = () => {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDelete = async (item) => {
    setDeletingId(item.itemid); // disable delete button
    setRemovingId(item.itemid); // start fade-out animation

    try {
      await handleDeleteProduct(item); // call parent delete logic
    } catch (err) {
      console.error("Delete error:", err);
      setRemovingId(null); // reset if failed
      setDeletingId(null);
      return;
    }

    // Delay removal so animation can finish
    setTimeout(() => {
      setRemovingId(null);
      setDeletingId(null);
      onUploadSuccess(); // refresh list or remove item locally
    }, 500); // must match CSS transition time
  };
  return (
    <>
      <h4 className="text-center" style={{ marginTop: "30px" }}>
        Recently Generated iSheets (Product A)
      </h4>
      <div className="table-responsive">
        <table
          className="table table-bordered border-primary"
          style={{ border: "1px solid red", fontSize: "14px" }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                #
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Riverchain ID
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Client name(English)
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Created date
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Created by
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Modified by
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Version
              </th>
              <th
                style={{
                  border: "1px solid green",
                  fontWeight: "bold",
                }}
              >
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              [...items]
                .sort((a, b) => {
                  // Find Created Date for any version
                  const createdA = a.column.find((col) =>
                    ["818", "2558"].includes(col.attributecolumnid)
                  )?.displaydata?.value;

                  const createdB = b.column.find((col) =>
                    ["818", "2558"].includes(col.attributecolumnid)
                  )?.displaydata?.value;

                  const dateA = createdA ? new Date(createdA) : new Date(0);
                  const dateB = createdB ? new Date(createdB) : new Date(0);

                  return dateB - dateA; // DESCENDING → newest first
                })
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((item, index) => (
                  <tr
                    key={item.itemid}
                    className={`fade-out ${
                      removingId === item.itemid ? "removing" : ""
                    }`}
                  >
                    {/* Serial Number */}
                    <td
                      style={{ border: "1px solid green", fontWeight: "bold" }}
                    >
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>

                    {/* Riverchain ID */}
                    <td style={{ border: "1px solid green" }}>
                      {item.column.find(
                        (col) =>
                          col.attributecolumnid === "835" ||
                          col.attributecolumnid === "2573"
                      )?.displaydata?.value || "--"}
                    </td>

                    {/* Client Name */}
                    <td style={{ border: "1px solid green" }}>
                      {item.column.find(
                        (col) =>
                          col.attributecolumnid === "821" ||
                          col.attributecolumnid === "2559"
                      )?.displaydata?.value || "--"}
                    </td>

                    {/* Created Date */}
                    <td style={{ border: "1px solid green" }}>
                      {item.column.find(
                        (col) =>
                          col.attributecolumnid === "818" ||
                          col.attributecolumnid === "2558"
                      )?.displaydata?.value || "--"}
                    </td>

                    {/* Created By */}
                    <td style={{ border: "1px solid green" }}>
                      {item.column.find(
                        (col) =>
                          col.attributecolumnid === "817" ||
                          col.attributecolumnid === "2557"
                      )?.displaydata?.lookupusers?.lookupuser
                        ?.userdisplayname || "--"}
                    </td>

                    {/* Extra Data */}
                    <td style={{ border: "1px solid green" }}>
                      {item.column
                        .filter(
                          (col) =>
                            col.attributecolumnid !== "818" &&
                            col.attributecolumnid !== "2558"
                        )
                        .slice(0, 1)
                        .map((col) => {
                          return (
                            col.rawdata?.value ||
                            col.displaydata?.lookupusers?.lookupuser
                              ?.userdisplayname ||
                            col.rawdata?.time ||
                            col.displaydata?.value ||
                            "--"
                          );
                        })}
                    </td>

                    {/* Version */}
                    <td style={{ border: "1px solid green" }}>
                      {item.version}
                    </td>

                    {/* Delete Button */}
                    <td style={{ textAlign: "center" }}>
                      <button
                        onClick={() => handleDelete(item)}
                        disabled={deletingId === item.itemid}
                        style={{
                          backgroundColor:
                            deletingId === item.itemid ? "gray" : "red",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          cursor:
                            deletingId === item.itemid
                              ? "not-allowed"
                              : "pointer",
                          borderRadius: "5px",
                        }}
                      >
                        {deletingId === item.itemid ? (
                          "Deleting..."
                        ) : (
                          <>
                            <FaRegTrashAlt /> Delete
                          </>
                        )}
                      </button>
                    </td>
                  </tr>
                ))
            ) : (
              <>Data is loading...</>
            )}
          </tbody>
        </table>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-primary"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>Page {currentPage}</span>
          <button
            className="btn btn-outline-primary"
            onClick={handleNextPage}
            disabled={currentPage === Math.ceil(items.length / itemsPerPage)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}
